import {sliderPhotosTpl} from '../../sliderPhotos/sliderPhotosTpl';
import {priceTooltipToggleTpl} from '../../priceToggle/priceToggleTpl';
import {cartoucheMultiCottageProduct} from '../../cartoucheMultiCottageProduct/cartoucheMultiCottageProduct';
import {getUriParams , htmlDiscountTpl} from './discountFlag';


const cartoucheDomain = function (datas) {
  const item = datas.item;
  const site = item.offer;
  const country = item.country;
  const region = item.region;
  const regionName = region.name.replace(/'/, '’');
  const destination = item.destination;
  const destinationName = destination.name.replace(/'/, '’');
  const wordings = datas.wordings;
  const housing = item.housing;
  const productCode = site.code;
  const actionCode = item.actionCode !== null ? item.actionCode.code : '';
  const brandCode = item.brand !== null ? item.brand.code : '';
  const pageTemplate = datas.pageTemplate;
  const siteName = site.name.replace(/'/, '’');
  const cartoucheType = typeof datas.cartoucheType !== 'undefined' ? datas.cartoucheType : 'regular';
  const cp_postfix = cartoucheType === 'counterproposal' ? '_CounterProp' : '';
  const cache = item.cache;
  const isDiscountSelected = typeof item.actionCode.promoType !== 'undefined' && (item.actionCode.promoType === '55' || item.actionCode.promoType === 'YF');
  const isGeoPage = pageTemplate === 'Region' || pageTemplate === 'Country' || pageTemplate === 'Destination';
  const hidePrice = typeof datas.hidePrice !== 'undefined' ? datas.hidePrice : false;
  const resultListSelected = datas.resultListSelected;
  const capacity = housing.capacity;
  const usps = site.usp;
  const hasMulticottage = datas.hasMulticottage;
  const hasBasket = sessionStorage.getItem('basketDatas') !== null;
  const currencySymbol = datas.currencySymbol || GLOBAL_SCRIPTS.CURRENCY_SYMBOL;
  const slider = sliderPhotosTpl({
    productCode: productCode,
    brandCode: brandCode,
    resolutionToUse: {
      desktop: '640x480',
      tablet: '640x480' ,
      mobile: '330x248'
    },
    openPopinOnClick: {
      desktop: true,
      tablet: true,
      mobile: true
    },
    photosDatas: datas.item.photo ? datas.item.photo : {
      '640x480': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/640x480.jpg'],
      '400x400': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/400x400.jpg'],
      '330x248': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/330x248.jpg']
    },
    typeOfResult: 'domain'
  });

  const wordingFilter = GLOBAL_SCRIPTS.WORDINGS_COMMON.filter_add_compare;
  const isComparator = GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B';

  let compareCheckbox = `${isComparator ? `<div class="sliderPhotos-compareContainer u-Hidden--forced"><div class="sliderPhotos-compareToggle toggle-${productCode}"><div class="sliderPhotos-checkbox-container"><input type="checkbox" class="js-compareTool compare-${productCode}" id="compare-${productCode}" name="compare-${productCode}" value="${productCode}">
  <label class="sliderPhotos-compareLabel" for="compare-${productCode}">${wordingFilter}</label></div></div></div>` : ''}`;

  let nbPets = 0;

  let LogoTHPicture = '';
  if (productCode === 'TH') {
    const srcImage = GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/logos/logo_terhills_black.svg';
    LogoTHPicture += `
      <picture class="cartoucheDomain-pictureContainer--logo js-hideTH">
        <img src="${srcImage}"  alt="Logo TH" itemprop="image" class="lazy">
        <noscript>
          <img src="${srcImage}" alt="Logo TH" />
        </noscript>
      </picture>`;
  }

  // FLEX_PERIOD
  const uriParams = getUriParams();
  const siteUri = site.uri + uriParams;
  const geoUri = item.extra.uri_geo + uriParams;
  /*const htmlHousingSpecial = site.nbHousingSpecial === 0 ? '' : '<li class="cartoucheDomain-info"><i class="icon icon-star"></i>' + site.nbHousingSpecial + wordings.infos_unusual_cottage_label + '</li>';
  const htmlSituation = site.situation ? `<p class="cartoucheDomain-textSituation u-Hidden-mobile">${site.situation}</p>` : '';
  const htmlCatch = site.catch ? `<p class="cartoucheDomain-textCatch">${site.catch}</p>` : '';*/

  // BLOC PRICE  AND DURATION //
  const oPrice = typeof cache.price !== 'undefined' && cache.price !== null ? cache.price : false;
  const promoPriceValue = oPrice ? parseInt(oPrice.promo.value, 10) : 0;
  const originalPriceValue = oPrice ? parseInt(oPrice.original.value, 10) : 0;

  let price = '';
  let strPrice = '';
  let strOldPrice = '';
  let htmlPrice = '';
  let htmlDuration = '';
  let htmlTooltipDuration = '';
  let tooltipDates = '';
  let htmlDates = '';
  let htmlBlockDateToSelect = `
    <div class="cartoucheDomain-noDateSelected js-openDateCartouche">
      <p><span class="mainLink">${SEARCH_SCRIPTS.WORDING_SEARCH.chooseDateBegin}</span>${SEARCH_SCRIPTS.WORDING_SEARCH.chooseDateEnd}</p>
    </div>`;

  if (oPrice) {
    if (promoPriceValue > 0 && promoPriceValue < originalPriceValue) {
      price = promoPriceValue;
      strPrice = oPrice.promo.formatted;
      strOldPrice = `${oPrice.original.value}<span class="currency">${currencySymbol}</span>` ;
    } else {
      price = originalPriceValue;
      strPrice = `${oPrice.original.value}<span class="currency">${currencySymbol}</span>`;
    }
  }

  const duration = cache.duration;
  if (duration > 1) {
    let wordingNight = duration === 1 ? wordings.common_night : wordings.common_nights;
    htmlDuration = (duration + 1) + '&nbsp;' + wordings.common_days + ' - ' + duration + '&nbsp;' + wordingNight;
    htmlTooltipDuration = duration + '&nbsp;' + wordingNight;
  }

  let htmlOccupancy = '';

  if (cache.date !== '') {
    const dateLabel = datesFromTo(cache.date, cache.dateEnd, GLOBAL_SCRIPTS.WORDINGS_COMMON.from_month, GLOBAL_SCRIPTS.WORDINGS_COMMON.to_month);
    const participantsSelected = typeof datas.resultListSelected !== 'undefined' && Object.prototype.hasOwnProperty.call(datas.resultListSelected, 'multiparticipants') ? datas.resultListSelected.multiparticipants : SEARCH_SCRIPTS.CURRENT_SEARCH_PARAMETERS.multiparticipants;
    const includedServicesArray = datas.item.housing.servicesIncludedV2;
    let includedServices = [];
    htmlDates = `${dateLabel} <span>(${htmlDuration})&nbsp;-&nbsp;${capacity}${GLOBAL_SCRIPTS.WORDINGS_COMMON.capacity_abrev}</span>`;
    tooltipDates = `${dateLabel} <span>(${htmlTooltipDuration})&nbsp;</span>`;
    price = datas.item.cache.price;

    if (typeof includedServicesArray !== 'undefined') {
      $.each(includedServicesArray, (i, service) => {
        if (service.regroupement === 'PRICEINCLUDE') {
          includedServices.push(service.name.replace(/'/g, '’'));
        }
      });
    }

    let dataMulticottage = typeof datas.item.cache.price.multicottage !== 'undefined' ? datas.item.cache.price.multicottage : [];
    let dataMulticottageToUse = [];
    $.each(dataMulticottage, (i, cottage) => {
      let includedServicesV2 = [];
      if (typeof cottage.housing.servicesIncludedV2 !== 'undefined') {
        $.each(cottage.housing.servicesIncludedV2, (i, service) => {
          if (service.regroupement === 'PRICEINCLUDE') includedServicesV2.push(service.name.replace(/'/g, '’'));
        });
      }
      dataMulticottageToUse[i] = {
        participants: participantsSelected[i],
        housingLabel: cottage.housing.specificName,
        cache: cottage.cache,
        housing: {
          servicesIncludedV2: includedServicesV2
        },
        price: cottage.price
      };
    });

    htmlOccupancy = priceTooltipToggleTpl({
      blockClass: 'accommodation-priceDetails',
      trackingGaAction: 'bloc accommodation',
      tooltipOptions: {
        includedServices: includedServices,
        typeTooltip: 'domaine',
        totalParticipants: datas.nbPersons,
        participants: {
          children: typeof participantsSelected === 'object' ? Object.prototype.hasOwnProperty.call(participantsSelected[0], 'ages') ? participantsSelected[0].ages.length : ((typeof participantsSelected[0].child !== 'undefined' ? participantsSelected[0].child.code : 0)  + (typeof participantsSelected[0].baby !== 'undefined' ? participantsSelected[0].baby.code : 0)) : 0,
          senior: typeof participantsSelected[0] === 'object' && typeof participantsSelected[0].senior !== 'undefined' ? participantsSelected[0].senior.code : 0,
          adult: typeof participantsSelected[0] === 'object' && typeof participantsSelected[0].adult !== 'undefined'? participantsSelected[0].adult.code : 2,
          pet: typeof participantsSelected[0] === 'object' && typeof participantsSelected[0].pet !== 'undefined'? participantsSelected[0].pet.code : 0
        },
        taxTotal: price.taxTotal,
        originalPrice: price.original.value,
        originalPriceRaw: price.original.raw,
        originalPriceRawBeforeTax: price.original.rawBeforeTax,
        petsPrice: price.pets.rawBeforeTax,
        differencePrice: price.difference,
        differencePriceRaw: price.rawDifference,
        discountLabel: datas.item.actionCode.name,
        housingLabel: datas.item.housing.housingType.name.replace(/'|"/g, '’') + ' ' + datas.item.housing.comfortLevel.name,
        dateLabel: tooltipDates,
        maxPersons: datas.item.cache.maxPersons,
        isLikeFancy: true,
        brandCode: datas.item.brand.code,
        productCode: datas.item.cache.offerCode,
        dataMulticottage: dataMulticottageToUse.length > 0 ? dataMulticottageToUse : 0
      }
    });
  }

  if (price !== '') {
    htmlPrice = `
      <p>
        <span class="prx-priceFrom">${wordings.domain_from_for_price}&nbsp;</span>
        <span class="prx-priceOldValue">${strOldPrice}</span>
        <span class="prx-priceValue">${strPrice}</span>
        ${htmlOccupancy}
      </p>`;
  }

  // Handling Pets Number on multicottage
  SEARCH_SCRIPTS.MULTIPARTICIPANTS.forEach(participant => {
    nbPets += participant.PETS_SELECTED;
  });

  /*** handling pets ***/
  const codeWordingPets = nbPets > 1 ? 'pet_label_plural' : 'pet_label_singular';
  const priceRaw = parseFloat(cache.price.pets.raw).toFixed(2);
  const priceRawForamtted = !GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? GLOBAL_SCRIPTS.CURRENCY_BEFORE + ' ' + priceRaw : priceRaw + ' ' + GLOBAL_SCRIPTS.CURRENCY_AFTER;
  const htmlPets = nbPets > 0 && typeof wordings[codeWordingPets] === 'string' ? ' ' + wordings[codeWordingPets].replace('%XX', nbPets).replace('%YY', priceRawForamtted) : '';
  const htmlPetsB = nbPets > 0 ? ' + ' + nbPets + ' ' + (nbPets > 1 ? GLOBAL_SCRIPTS.WORDINGS_COMMON.pets : GLOBAL_SCRIPTS.WORDINGS_COMMON.pet) : '';

  const pricingWrd = datas.controller === 'singleclick' && SEARCH_SCRIPTS.DISPLAY_PRICE !== 'default' ? SEARCH_SCRIPTS.DISPLAY_PRICE : (hasMulticottage ?  'per_stay_plural' : 'per_stay');
  const htmlPricingLabel = `<p class="prx-priceLegal">${wordings[pricingWrd]}${htmlPetsB}</p>`;
  const htmlLegal = wordings.accommodation_price_condition !== 'accommodation_price_condition' && wordings.accommodation_price_condition !== '' ? '<p class="prx-durationlegal">' + wordings.accommodation_price_condition + '</p>' : '';

  let htmlBlocPrice = '';
  if ((price !== '' || item.duration > 0) || htmlDuration !== '') {
    htmlBlocPrice = `
      <div class="prx-duration">
        <p class="prx-durationtext">
          ${htmlDates}
        </p>
        ${htmlLegal}
      </div>
      <div class="prx-price">
        ${htmlPrice}
        ${htmlPricingLabel}
      </div>`;
  }
  let htmlBookButton = `
    <a class="js-buttonLoader buttonContainer cartoucheDomain-bookButton js-displayHousings js-Tracking--link" href="${site.url_cottages}"
      data-target="#js-accommodation_${productCode}"
      data-code="${productCode}"
      data-actioncode="${actionCode}"
      data-portalcode="${SEARCH_SCRIPTS.PORTAL_CODE}"
      data-startdate="${cache.date}"
      data-enddate="${cache.dateEnd}"
      data-labelopen="${wordings.housing_cartouche_show}"
      data-labelclose="${wordings.housing_cartouche_hide}"
      data-cartouchetype="${cartoucheType}"
      data-tracking='{"clickCode":"clickDomainPriceButton${cp_postfix}","gaCategory":"${pageTemplate}${cp_postfix}","gaAction":"Domain price button${cp_postfix}","gaLabel":"${wordings.housing_cartouche_show}${cp_postfix}","gaValue":1,"accommodationCode":"${productCode}"}'>
      <span class="button button--pinkWhite">
        ${wordings.housing_cartouche_show}
      </span>
    </a>`;

  //handling dispo alert
  let htmlDispoAlert = '';
  if (item.stress.offerOccupancyAlert) {
    const ratioDispo = Math.round(item.stress.offerOccupancyRate);
    htmlDispoAlert = `
      <div class="cartoucheDomain-alertDispo">
        <span class="pseudoIco-alert">${typeof wordings.alert_domain === 'string' ? wordings.alert_domain.replace('%XX', ratioDispo) : ''}</span>
      </div>`;
  }

  const isSearchOrGeoPage = PAGE_SCRIPTS.page_template === 'Search' || isGeoPage;
  const htmlDiscoverParkLink = isSearchOrGeoPage ? `
    <a class="ctDom-discover mainLink js-postParams js-Tracking--link" target="_blank" href="${site.url}" data-urlparams="${siteUri}" data-tracking='{"clickCode":"","gaCategory":"${pageTemplate}","gaAction":"USP Bloc parcs","gaLabel":"Discover the domain","event":"clickEvent"}'>
      ${wordings.domain_visit_domain}
    </a>` : '';

  let uspsListItems = '';

  $.each(usps, function (i, usp) {
    const iconsTH = productCode === 'TH' ? 'TH/' : '';
    const iconeSrc = GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/product/pictosUSP/' + iconsTH + 'usp-' + usp.classification + '.svg';
    uspsListItems += `
      <li class="ctDom-uspBlockItem${i === 0 ? ' active' : ''}">
        <img src="${iconeSrc}" alt="${usp.name}"/>
        <p>${usp.teaser}</p>
      </li>`;
  });

  let dataTrackingBtn;
  if(isSearchOrGeoPage){
    const eventLabelBase = item.offer.name + '_' + datas.position;
    const eventlabel = !!item.extra.geo_distance ? eventLabelBase +'_'+ parseInt(item.extra.geo_distance)+'km': eventLabelBase ;
    dataTrackingBtn = '{"event": "clickEvent","gaCategory": "Search","gaAction": "Domain price button","gaLabel": "' + eventlabel + '","accommodationCode": "' + item.extra['offer.code'] + '"}' ;
  }
  else{
    dataTrackingBtn ='{"clickCode":"clickDomainAccess' + cp_postfix + '","gaCategory":"'+ pageTemplate + cp_postfix + '","gaAction":"Domain access' + cp_postfix + '","gaLabel":"pos' + datas.position + ' - click' + cp_postfix + '","gaValue":1, "accommodationCode":' + productCode + '"}';
  }
  const dataTrackingEncode = dataTrackingBtn.replaceAll('"', '&quot;');

  let htmlDiscoverParkButton = `
   <a class="js-buttonLoader buttonContainer js-postParams js-Tracking--link" target="_blank" href="${isSearchOrGeoPage ? site.url_cottages : site.url}" data-urlparams="${siteUri}" data-tracking="${dataTrackingEncode}"}'>
    <span class="button ${isSearchOrGeoPage ? 'button--pinkWhite' : 'button--transparentBlack'}">
      ${isSearchOrGeoPage ? wordings.housing_cartouche_show : wordings.domain_visit_domain}
    </span>
  </a>`;

  let productLabel = '';
  if (site.isNew) {
    productLabel = `<span class="productLabel">${wordings.product_label_new}</span>`;
  } else if (site.isRenovated) {
    productLabel = `<span class="productLabel">${wordings.product_label_renovated}</span>`;
  }

  let cartouche = `
      <div class="ctDom" id="cartouche_${productCode}">
        <div class="ctDom-ctnr">
          ${isDiscountSelected ? htmlDiscountTpl(wordings, 'tabletOrMobile') : ''}
          <div class="cartoucheDomain-pictureContainer">
            ${compareCheckbox}
            ${slider}
            ${LogoTHPicture}
          </div>
          <div class="ctDom-infoContnr">
            <div class="ctDom-titleBlock">
              <a class="js-Tracking--link js-postParams" href="${site.url}" target="_blank" data-urlparams="${siteUri}" data-tracking='{"clickCode":"clickDomainTitle","gaCategory":"${pageTemplate}","gaAction":"Domain title link","gaLabel":"pos${datas.position} - ${siteName}","gaValue":1, "accommodationCode":"${productCode}"}'>
                <span class="ctDom-title">${siteName}</span>
                ${productLabel}
              </a>
              <p class="ctDom-titleGeo">
                <a href="${country.url}" data-urlparams="${geoUri}" title="${country.name}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickDomainBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Domain breadcrumb country","gaLabel":"${country.name}","gaValue":1}'>${country.name}</a>,
                <a href="${region.url}" data-urlparams="${geoUri}" title="${regionName}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickDomainBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Domain breadcrumb region","gaLabel":"${regionName}","gaValue":1}'>${regionName}</a>,
                <a href="${destination.url}" data-urlparams="${geoUri}" title="${destinationName}" class="cartouche-geoLink js-Tracking--link js-postParams" target="_blank" data-tracking='{"clickCode":"clickDomainBreadcrumb","gaCategory":"${pageTemplate}","gaAction":"Domain breadcrumb destination","gaLabel":"${destinationName}","gaValue":1}'>${destinationName}</a>
                ${geoloc.distance.renderLabel({value: item.extra.geo_distance, icon: 'arrow-diagonal'})}
              </p>
              <div class="ctDom-titleText">
                ${!DEVICE.isMobile ? site.catch : ''}
                ${htmlDiscoverParkLink}
              </div>
            </div>
            ${usps.length ?
    `<div class="ctDom-uspBlock">
              <ul class="ctDom-uspBlockList">
                ${uspsListItems}
              </ul>
            </div>` : ''}
          </div>
          <div class="ctDom-priceContnr">
            ${!hidePrice ? htmlBlocPrice : htmlBlockDateToSelect}
            <div class="prx-button">
              ${!isSearchOrGeoPage ? htmlBookButton : htmlDiscoverParkButton}
            </div>
          </div>
        </div>`;

  if (!isSearchOrGeoPage) {
    cartouche += `
        <div id="js-accommodation_${productCode}" class="accCartList">
          <div id="js-smallCartoucheContainer_${productCode}" class="accCart-container"></div>
        </div>`;
  }
  cartouche += '</div>';

  if (!isSearchOrGeoPage) {
    cartouche += `
    <div id="js-accommodation_${productCode}" class="accCartList">`;
    if (hasMulticottage && !hasBasket) {
      cartouche += cartoucheMultiCottageProduct({
        title: GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitle + ' 1',
        number: '1',
        participants: {
          senior: resultListSelected && resultListSelected.multiparticipants[0].senior ? resultListSelected.multiparticipants[0].senior.code : 0,
          adult: resultListSelected && resultListSelected.multiparticipants[0].adult ? resultListSelected.multiparticipants[0].adult.code : 0,
          child: resultListSelected && resultListSelected.multiparticipants[0].ages ? resultListSelected.multiparticipants[0].ages.length : 0,
          pet: resultListSelected && resultListSelected.multiparticipants[0].pet ? resultListSelected.multiparticipants[0].pet.code : 0
        }
      });
    }
    cartouche += `
      <div id="js-smallCartoucheContainer_${productCode}" class="accCart-container"></div>
    </div>`;
  }

  cartouche += `
    </div>`;

  return cartouche;
};

export { cartoucheDomain };